import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import partialUser from "../../../identity/services/fragments/PartialUser"

const query = gql`
query getCelebrationsReport(
$businessId: ID!,
$regionIds: [ID!],
$duration: CelebrationsReportDuration,
$category: CelebrationsReportCategory,
$limit: Int) {
  celebrationsReport(businessId: $businessId, regionIds: $regionIds, duration: $duration, category: $category, limit: $limit) {
    recognition {
      users {
        uuid
        recognitionIds
        companyValues {
          name
          count
          icon {
            href
            alt
          }
        }
        user {
          firstName
          lastName
          teams {
            results {
              public_name
            }
          }
        }
        regionName
      }
      teams {
        recognitionIds
        companyValues {
          name
          count
          icon {
            href
            alt
          }
        }
        team {
          teamName
          users {
            total
            results {
              ...partialUser
            }
          }
        }
      }
    }
  }
}
${partialUser}
`

export const celebrationsReportKey = getQueryNames(query)[0]

export default query
